<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-dialog v-model="dialog" max-width="800px">
            <food-edit-form :editedItem="editedItem" :editedIndex="editedIndex" @snackbar="displaySnackbar" @updateItem="updateItem" :dialog.sync="dialog" />
        </v-dialog>

        <v-dialog v-model="tagDialog" max-width="400px">
            <v-form ref="tagForm" v-model="valid">
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        Create a new tag
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="tagName" label="Tag name" :rules="[v => !!v || 'Name is required']"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="createTag" :disabled="!valid">Create</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="helpDialog" max-width="800px">
            <query-info :dialog.sync="helpDialog" />
        </v-dialog>

        <v-layout
                text-xs-center
                wrap
        >
            <v-flex xs12>
                <v-card flat class="mb-4 flat-card">
                    <v-card-title>
                        <h3>Search ingredients</h3>
                        <v-spacer></v-spacer>
                        <v-btn @click="addIngredientDialog = true" text color="primary">Create Ingredient<v-icon right>add</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-layout wrap>
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field v-model="searchText" label="What are you looking for?" @keyup.native.enter="search"  @click:append="search" append-icon="search" prepend-icon="help_outline" @click:prepend="helpDialog=true" :loading="searchLoading"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4 px-2>
                                    <v-select :items="nutrientItems" item-text="nutrientname" item-value="id" v-model="orderBy" label="Order by" clearable></v-select>
                                </v-flex>
                                <v-flex xs12 sm2 px-2>
                                    <v-text-field v-model="limit" label="Results limit"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap>
                                <v-flex xs12 px-2>
                                    <v-subheader class="px-0">Search by tags</v-subheader>
                                    <div class="text-xs-left">
                                        <template v-for="tag in tags">
                                            <v-chip :close="close" color="blue-grey" class="mx-1 white--text" @click="searchByTag(tag.id)" @click:close="deleteTag(tag.name)">{{ tag.name }}</v-chip>
                                        </template>
                                        <v-chip color="blue-grey" outlined class="mx-1 white--text" @click="tagDialog=true"><v-icon>add</v-icon>Create tag</v-chip>
                                        <v-chip color="blue-grey" outlined class="white--text" @click="close=!close"><v-icon>remove</v-icon>Delete tag</v-chip>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-title>
                        <h3>Results</h3>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="filter"
                                append-icon="search"
                                label="Filter results"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            flat
                            :loading="tableLoading"
                            :headers="headers"
                            hide-default-header
                            hide-default-footer
                            height="600"
                            no-results-text="No results"
                            :items="items"
                            item-key="foodid"
                            :items-per-page="-1"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            fixed-header
                            :search="filter"
                            class="elevation-0">

                        <template v-slot:header="{ props: { headers } }">
                            <thead class="v-data-table-header">
                                <tr>
                                    <th
                                            v-for="header in headers"
                                            :key="header.text"
                                            :class="['column sortable', sortDesc ? 'desc' : 'asc', header.value === sortBy ? 'active' : '']"
                                            @click="changeSort(header.value)"
                                    >
                                        {{ header.text }}
                                    </th>
                                    <th v-for="(nutrient, key) in nutrients"
                                        :key="key"
                                        :class="['column sortable', sortDesc ? 'desc' : 'asc', `nutrients.${key}.value` === sortBy ? 'active' : '']"
                                        @click="changeSort(`nutrients.${key}.value`)">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <span v-on="on">
                                                    <v-icon small>arrow_upward</v-icon>
                                                    {{nutrient.nutrientsymbol}}({{nutrient.unit}})
                                                </span>
                                            </template>
                                            <span>{{nutrient.nutrientname}}</span>
                                        </v-tooltip>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-icon
                                    small
                                    class="mr-2"
                                    @click="editItem(item)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                    small
                                    @click="deleteItem(item)"
                            >
                                delete
                            </v-icon>
                        </template>
                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr v-for="item in items" :key="item.name">
                                    <td class="text-xs-left layout px-0 align-center">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on"
                                                        class="mx-2 pl-2"
                                                        color="blue"
                                                        @click.stop.prevent="displayFoodDetails(item)"
                                                >
                                                    info
                                                </v-icon>
                                            </template>
                                            <span>Show food nutrients</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2 pl-2"
                                                        color="blue-grey"
                                                        @click.stop.prevent="editItem(item)"
                                                >
                                                    edit
                                                </v-icon>
                                            </template>
                                            <span>Edit item</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2"
                                                        color="green"
                                                        @click.stop.prevent="addToMeal(item)"
                                                >
                                                    add
                                                </v-icon>
                                            </template>
                                            <span>Select ingredient</span>
                                        </v-tooltip>


                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        v-if="user.role === 1"
                                                        class="mx-2"
                                                        color="red"
                                                        @click.stop.prevent="deleteFood(item.foodid)"
                                                >
                                                    delete
                                                </v-icon>
                                            </template>
                                            <span>Delete Ingredient</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="text-xs-left">{{ item.foodid }}</td>
                                    <td class="text-xs-left">{{ item.fooddescription }}</td>
                                    <td class="text-xs-left">{{ item.fooddescriptionsimple }}</td>
                                    <td class="text-xs-left"><v-icon v-if="item.local" color="green">check_circle</v-icon><v-icon v-else-if="item.local === false" color="red">cancel</v-icon></td>
                                    <td class="text-xs-left">{{ item.environmentalimpact }}</td>
                                    <td class="text-xs-left"><v-icon v-if="item.organic" color="green">check_circle</v-icon><v-icon v-else-if="item.organic === false" color="red">cancel</v-icon></td>
                                    <td class="text-xs-left">{{ item.price }}</td>
                                    <td class="text-xs-left">
                                            <div><template v-if="item.tags !== null" v-for="(tag, index) in item.tags">{{ index === 0 ? tag : ', ' + tag }}</template></div>
                                    </td>
                                    <template v-for="(value, key) in nutrients">
                                        <td>{{item.nutrients[key] ? item.nutrients[key].value : 0}}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="infoDialog" scrollable>
            <v-card flat v-if="editedItem && editedItem.nutrients">
                <v-card-title class="headline">Nutrient info for {{editedItem.fooddescription}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-xs-left">
                    <v-layout wrap>
                        <v-flex xs6 v-for="(nutrient, key) in nutrients" :key="nutrient.nutrientsymbol" v-if="editedItem.nutrients[key] && parseFloat(editedItem.nutrients[key].value) > 0.0">
                            <div><strong>{{nutrient.nutrientname}}</strong>: {{editedItem.nutrients[key].value}}{{nutrient.unit}}</div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="infoDialog = false" color="primary">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addIngredientDialog" width="800">
            <AddIngredient @close="addIngredientDialog = false" @displaySnackbar="displaySnackbar" />
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                :timeout="timeout"
                :color="snackbarColor"
                top
        >
            <strong>{{ snackbarText }}</strong>
            <v-btn
                    color="white"
                    text
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import FoodService from '../services/FoodService';
    import FoodEditForm from '@/components/partials/FoodEditForm';
    import AddIngredient from '@/components/partials/AddIngredient';
    import QueryInfo from '@/components/partials/QueryInfo';
    import { mapGetters } from 'vuex';
    import ComponentService from '../services/ComponentService';

    export default {
        data: () => ({
            chip: {},
            close: false,
            dialog: false,
            helpDialog: false,
            infoDialog: false,
            addIngredientDialog: false,
            tagDialog: false,
            valid: false,
            tagName: '',
            snackbar: false,
            snackbarText: '',
            snackbarColor: '',
            timeout: 4000,
            limit: 50,
            searchLoading: false,
            tableLoading: false,
            filter: '',
            headers: [
                {sortable: false},
                {
                    text: 'ID',
                    align: 'left',
                    value: 'foodid'
                },
                { text: 'Description', value: 'fooddescription' },
                { text: 'Simple Description', value: 'fooddescriptionsimple' },
                { text: 'Local', value: 'local' },
                { text: 'Environmental impact', value: 'environmentalimpact' },
                { text: 'Organic', value: 'organic' },
                { text: 'Price', value: 'price' },
                { text: 'Tags', value: 'tags'}
            ],
            sortBy: '',
            sortDesc: '',
            items: [],
            searchText: '',
            orderBy: null,
            editedIndex: -1,
            editedItem: {
                foodid: 0,
                fooddescription: '',
                fooddescriptionsimple: '',
                local: null,
                price: 0,
                tags: []
            },
          tag: null
        }),
      props: {
          component: String,
        meal: Number
      },
      components: {
        FoodEditForm, QueryInfo, AddIngredient
      },
      computed: {
        ...mapGetters({
          tags: 'getTags',
          nutrients: 'getNutrients',
          user: 'getUser'
        }),
        nutrientItems() {
          const nutrients = [];
          for (const key in this.nutrients) {
            if (this.nutrients.hasOwnProperty(key)) {
                const nutrient = this.nutrients[key];
                nutrient.id = key;
                nutrient.nutrientname = nutrient.nutrientname.toLowerCase();
                nutrients.push(nutrient);
            }
          }
          return nutrients;
        }
      },
        methods: {
            async search() {
                try {
                  this.searchLoading = true;
                  const response = await FoodService.getFoodList({
                    search: this.searchText,
                    limit: this.limit,
                    order: this.orderBy
                  });
                  if (this.orderBy) {
                    this.pagination.sortBy = `nutrients.${this.orderBy}.value`;
                    this.pagination.descending = true;
                  }
                  this.items = response.data;
                } catch (e) {
                    this.displaySnackbar(e.message, 'error');
                } finally {
                  this.searchLoading = false;
                }
            },
            editItem(item) {
                this.editedIndex = this.items.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            async addToMeal(item) {
              try {
                this.tableLoading = true;
                const response = await FoodService.getMeasures(item.foodid);
                item.measures = [{measureid: 1455, measurename: '100g', conversionfactorvalue: 1.0}, ...response.data];
                item.portion_multiplier = 1;
                item.portion_basis = 1455;
                if (this.component && this.meal) {
                  if (item.component_id) {
                    const { data } = await ComponentService.getComponent(item.component_id);
                    for (const food of data.foods) {
                      food.component = data.id;
                      food.mealid = this.meal;
                    }
                    this.$store.dispatch('addDayFoods', data.foods);
                  } else {
                      item.component = this.component === 'other' ? null : this.component;
                      item.mealid = this.meal;
                      this.$store.dispatch('addDayFoods', [item]);
                  }
                } else if (item.component_id) { // if the ingredient is actually a component add foods from this component
                  const { data } = await ComponentService.getComponent(item.component_id);
                  for (const food of data.foods) {
                    food.component = data.id;
                  }
                  this.$store.dispatch('addIngredientsToMeal', data.foods);
                } else {
                    const itemCopy = Object.assign({}, item);
                    this.$store.dispatch('addIngredientToMeal', itemCopy);
                }
                this.displaySnackbar('Ingredient added to meal!', 'blue-grey');
              } catch (e) {
                this.displaySnackbar(e.message, 'error');
              } finally {
                this.tableLoading = false;
                this.$emit('update:dialog', false);
                this.$emit('snackbar', 'Ingredient added!', 'blue-grey');
              }
            },
            async searchByTag(id) {
              this.searchLoading = true;
              try {
                  const response = await FoodService.searchByTag(id);
                  this.items = response.data;
              } catch (e) {
                this.displaySnackbar(e.message, 'error');
              } finally {
                this.searchLoading = false;
              }
            },
            async createTag() {
                const response = await FoodService.addFoodTag(this.tagName);
                if (response.status >= 200 && response.status < 400) {
                  this.$store.dispatch('addTags', response.data);
                  this.displaySnackbar('Tag created!', 'blue-grey');
                }
                this.tagDialog = false;
            },
            async deleteTag(name) {
              const response = confirm(`Are you sure you want to delete the tag '${name}'?`)
                && await FoodService.deleteTag(name);
              if (response.status >= 200 && response.status < 400) {
                this.$store.dispatch('removeTag', name);
                this.displaySnackbar('Tag deleted!', 'blue-grey');
              }
            },
            displaySnackbar(msg, color) {
              this.snackbarText = msg;
              this.snackbarColor = color;
              this.snackbar = true;
            },
            async deleteFood(id) {
              try {
                this.tableLoading = true;
                const response = confirm('Are you sure you want to delete this ingredient? This cannot be undone.')
                  && await FoodService.deleteFood(id);
                if (response.status >= 200 && response.status < 400) {
                    const index = this.items.findIndex((item) => item.foodid === id);
                    this.items.splice(index, 1);
                    this.displaySnackbar('Ingredient deleted!', 'blue-grey');
                }
              } catch (e) {
                this.displaySnackbar(e.message, 'error');
              } finally {
                this.tableLoading = false;
              }
            },
            changeSort(column) {
                if (this.sortBy === column) {
                  this.sortDesc = !this.sortDesc;
                } else {
                  this.sortBy = column;
                  this.sortDesc = false;
                }
            },
            updateItem(index, data) {
              this.items[index].tags = data.tags;
              this.items[index].price = data.price;
              this.items[index].fooddescriptionsimple = data.fooddescriptionsimple;
              this.items[index].local = data.local;
              this.items[index].environmentalimpact = data.environmentalimpact;
              this.items[index].organic = data.organic;
            },
            displayFoodDetails(item) {
              this.editedItem = item;
              this.infoDialog = true;
            }
        }
    };
</script>

<style>

</style>
